import { endpoints } from "./endpoints";

export const environment = {
	firebaseConfig: {
		apiKey: "AIzaSyCmL4ZpPn38QuD22m98ChPOk7uO-sOVhdo",
		authDomain: "kominplis-330ee.firebaseapp.com",
		projectId: "kominplis-330ee",
		storageBucket: "kominplis-330ee.firebasestorage.app",
		messagingSenderId: "79272401317",
		appId: "1:79272401317:web:efabd85936a3515500f04c"
	},
	production: true,

	api: {
		files: "https://kominplis.nytelweb.com/public/",
		host: "https://kominplis.nytelweb.com/",
		url: "https://api.kominplis.nytelweb.com/api/auth/",
		// url: "http://192.168.20.129/KominplisApi/api/auth/",
		...endpoints.api,
	},
	countries: endpoints.countries,
};
